import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Folder = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M4.1799 19.5H17.6663C18.5345 19.5 19.3019 18.9315 19.5609 18.0966L21.2041 12.7983C21.4038 12.1544 20.9264 11.5 20.2568 11.5H19.6219M4.1799 19.5C4.80532 19.5 5.35817 19.0905 5.54472 18.489L7.27704 12.9035C7.53599 12.0685 8.30343 11.5 9.17161 11.5H19.6219M4.1799 19.5C3.39019 19.5 2.75 18.855 2.75 18.0593V6.50003C2.75 5.39546 3.63868 4.50003 4.73492 4.50003H8.63494C9.2986 4.50003 9.91836 4.83423 10.2865 5.39063L11.3875 7.05473C11.5716 7.33293 11.8815 7.50003 12.2133 7.50003H17.6369C18.7332 7.50003 19.6219 8.39546 19.6219 9.50003V11.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.73074 3.75C3.2226 3.75 2 4.98122 2 6.5V18.0592C2 19.2692 2.97397 20.25 4.17542 20.25H17.6691C18.8635 20.25 19.9193 19.4683 20.2756 18.3203L21.9197 13.022C22.2584 11.9305 21.4847 10.8219 20.3705 10.7534V9.5C20.3705 7.98122 19.1479 6.75 17.6397 6.75H12.2132C12.1302 6.75 12.0527 6.70822 12.0066 6.63867L10.905 4.97457C10.3985 4.20953 9.54589 3.75 8.63286 3.75H4.73074ZM9.16982 10.75H18.881V9.5C18.881 8.80964 18.3252 8.25 17.6397 8.25H12.2132C11.6321 8.25 11.0896 7.95757 10.7673 7.47073L9.66564 5.80662C9.43543 5.45888 9.04788 5.25 8.63286 5.25H4.73074C4.04522 5.25 3.4895 5.80964 3.4895 6.5V18.0592C3.4895 18.4407 3.7966 18.75 4.17542 18.75C4.47544 18.75 4.74064 18.5537 4.83013 18.2653L6.56338 12.6797C6.91964 11.5317 7.97544 10.75 9.16982 10.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
